module.exports = __webpack_public_path__ + "static/media/family-small.0595e3ef.png";